import React, { useState } from 'react';
import { Video } from 'lucide-react';
import { PresentationTab } from './presentations/PresentationTab';
import { PresentationHeader } from './presentations/PresentationHeader';
import { PresentationPhotoGrid } from './presentations/PresentationPhotoGrid';
import { BarlettaPresentation } from './presentations/BarlettaPresentation';
import { LuceraPresentation } from './presentations/LuceraPresentation';
import {
  presentationsData,
  barlettaPhotos,
  cutrofianoPhotos,
  andriaPhotos,
  luceraPhotos,
  traniPhotos,
} from './presentations/presentationsData';

export const Presentations = () => {
  const [activeTab, setActiveTab] = useState('barletta');

  return (
    <section id="presentazioni" className="section-container bg-bg-card py-24">
      <div className="container mx-auto px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Video className="w-8 h-8 text-brand-primary" />
              <h2 className="heading-1 text-brand-primary">Presentazioni del Libro</h2>
            </div>
            <div className="w-24 h-1 bg-brand-primary mx-auto mb-8"></div>
            <p className="body-medium text-text-secondary">
              Gli eventi di presentazione di "Cronache dal fronte invisibile"
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <PresentationTab
              active={activeTab === 'barletta'}
              label="Barletta - 3.3.2026"
              onClick={() => setActiveTab('barletta')}
              testId="presentations-tab-barletta"
            />
            <PresentationTab
              active={activeTab === 'cutrofiano'}
              label="Cutrofiano (LE) - 21.03.2026"
              onClick={() => setActiveTab('cutrofiano')}
              testId="presentations-tab-cutrofiano"
            />
            <PresentationTab
              active={activeTab === 'andria'}
              label="Comitato Elettorale Giovanna Bruno Sindaco - 27.4.2026"
              onClick={() => setActiveTab('andria')}
              testId="presentations-tab-andria"
            />
            <PresentationTab
              active={activeTab === 'lucera'}
              label="Lucera (FG) - 20.5.2026"
              onClick={() => setActiveTab('lucera')}
              testId="presentations-tab-lucera"
            />
            <PresentationTab
              active={activeTab === 'trani'}
              label="Versante Est Trani - 30.8.2026"
              onClick={() => setActiveTab('trani')}
              testId="presentations-tab-trani"
            />
          </div>

          <div className="max-w-4xl mx-auto">
            {activeTab === 'barletta' && (
              <BarlettaPresentation data={presentationsData.barletta} photos={barlettaPhotos} />
            )}

            {activeTab === 'cutrofiano' && (
              <div className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden">
                <PresentationHeader
                  title={presentationsData.cutrofiano.title}
                  date={presentationsData.cutrofiano.date}
                  location={presentationsData.cutrofiano.location}
                />
                <PresentationPhotoGrid
                  photos={cutrofianoPhotos}
                  altPrefix="Presentazione Cutrofiano"
                />
              </div>
            )}

            {activeTab === 'andria' && (
              <div
                className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden"
                data-testid="presentations-content-andria"
              >
                <PresentationHeader
                  title={presentationsData.andria.title}
                  date={presentationsData.andria.date}
                  location={presentationsData.andria.location}
                />
                <PresentationPhotoGrid
                  photos={andriaPhotos}
                  altPrefix="Comitato Elettorale Giovanna Bruno Sindaco"
                  testIdPrefix="presentations-andria-photo"
                />
              </div>
            )}

            {activeTab === 'lucera' && (
              <LuceraPresentation
                data={presentationsData.lucera}
                photos={luceraPhotos}
                videoSrc="/lucera-video.mp4"
              />
            )}

            {activeTab === 'trani' && (
              <div
                className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden"
                data-testid="presentations-content-trani"
              >
                <PresentationHeader
                  title={presentationsData.trani.title}
                  date={presentationsData.trani.date}
                  location={presentationsData.trani.location}
                />
                <PresentationPhotoGrid
                  photos={traniPhotos}
                  altPrefix="Presentazione Versante Est Trani"
                  testIdPrefix="presentations-trani-photo"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
